module.exports = __webpack_public_path__ + "img/S-WEB-Goal-07.d5b5e266.png";